var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatchmentIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 761.451,
    height: 981.696,
    viewBox: "0 0 761.451 981.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(1824.725 -4947.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M378.931.046C565.705,0,726.449,132.4,755.425,314.633c25.539,160.629-30.217,291.5-165.029,383.056-82.6,56.1-149.724,186.832-196.951,274.5-2.707,5.024-5.908,9.368-12.233,9.5-6.812.149-10.087-4.551-12.954-9.829-47.018-86.449-113.735-217.438-195.066-271.922C86.233,641.69,29.573,561.851,8.662,459.08c-24.713-121.454,3.56-230.905,83.489-325.661C152.837,61.474,231.2,19.331,324.033,4.3a312.67,312.67,0,0,1,54.9-4.252",
    transform: "translate(-1824.725 4947.211)",
    fill: "#17ad99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(-1734 5032)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 290,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 289.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(-221.996 -79.171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 434.222,
    height: 50.526,
    transform: "translate(-1439.115 5496.777)",
    fill: "#9393bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 13.614,
    height: 221.437,
    transform: "translate(-1422.457 5291.175)",
    fill: "#9393bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 13.614,
    height: 221.437,
    transform: "translate(-1035.179 5291.175)",
    fill: "#9393bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 434.222,
    height: 13.614,
    transform: "translate(-1439.115 5284.369)",
    fill: "#9393bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M93.88,67.172H29.287a6.313,6.313,0,0,0,0,12.626H31.1V291.353a30.48,30.48,0,1,0,60.961,0V79.8H93.88a6.313,6.313,0,0,0,0-12.626",
    transform: "translate(-1421.248 5158.657)",
    fill: "#5a5a85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M62.9,259.551V74.281H27.552v185.27a17.672,17.672,0,1,0,35.343,0",
    transform: "translate(-1404.884 5184.068)",
    fill: "#ffc87e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M113.941,67.172H49.348a6.313,6.313,0,0,0,0,12.626h1.816V291.353a30.48,30.48,0,1,0,60.961,0V79.8h1.816a6.313,6.313,0,0,0,0-12.626",
    transform: "translate(-1349.538 5158.657)",
    fill: "#5a5a85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M82.956,259.551V74.281H47.613v185.27a17.672,17.672,0,1,0,35.343,0",
    transform: "translate(-1333.174 5184.068)",
    fill: "#fa518d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M134,67.172H69.409a6.313,6.313,0,0,0,0,12.626h1.816V291.353a30.48,30.48,0,1,0,60.961,0V79.8H134a6.313,6.313,0,0,0,0-12.626",
    transform: "translate(-1277.827 5158.657)",
    fill: "#5a5a85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M103.02,259.551V74.281H67.672v185.27a17.674,17.674,0,0,0,35.348,0",
    transform: "translate(-1261.473 5184.068)",
    fill: "#f27187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M154.063,67.172H89.474a6.313,6.313,0,1,0,0,12.626h1.816V291.353a30.478,30.478,0,1,0,60.956,0V79.8h1.816a6.313,6.313,0,0,0,0-12.626",
    transform: "translate(-1206.121 5158.657)",
    fill: "#5a5a85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M123.077,259.551V74.281H87.734v185.27a17.671,17.671,0,1,0,35.343,0",
    transform: "translate(-1189.76 5184.068)",
    fill: "#faccce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 434.222,
    height: 13.614,
    transform: "translate(-1439.115 5346.348)",
    fill: "#9393bf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatchmentIc);
export default __webpack_public_path__ + "static/media/catchment-ic.d10ec862ba29e78df156e984cd54c556.svg";
export { ForwardRef as ReactComponent };